import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as Const from "../../Data/const";
import { parseUrlParameter } from "../../Lib/Utils";
import { withTranslation } from "react-i18next";
// components
import ButtonSNS from "../../Components/Button";

// styles
import verificationStyle from "../../Styles/Containers/Verification.module.css";

class LoginContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: true,
      loginType: ""
    };

    //페이스북 테스트 라이브러리 사용

    // 페이스북 테스트
    this.handleFBLoginTest = this.handleFBLoginTest.bind(this);

    // 페이스북
    this.handleFBLogin = this.handleFBLogin.bind(this);

    // 라인
    this.handleLineLogin = this.handleLineLogin.bind(this);

    // 웨이보
    this.handleWeiboLogin = this.handleWeiboLogin.bind(this);
  }

  componentDidMount() {
    if (this.props.onRef !== undefined) this.props.onRef(this);
  }

  handleFBLoginTest() {
    let redirect_uri = window.location.origin + "/user/facebook/redirect";

    let query = parseUrlParameter.parse(window.location.search);

    query.redirect_uri = redirect_uri;
    query.href = window.location.pathname;

    let parsedQuery = (Object.keys(query) || [])
      .map(key => {
        return '"' + key + '":"' + query[key] + '"';
      })
      .join(",");

    window.location.href =
      "https://www.facebook.com/v4.0/dialog/oauth?" +
      "client_id=591938726219696" +
      "&redirect_uri=" +
      redirect_uri +
      "&state={" +
      parsedQuery +
      "}";
  }
  handleFBLogin() {
    window.android.doFacebookLogin();
  }

  handleLineLogin() {
    // 라인 state 암호화 필요???
    window.location.href =
      "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=" +
      Const.LINE.client_id +
      "&redirect_uri=" +
      window.location.origin +
      "/user/line/redirect&state=" +
      (window.location.pathname +
        (window.location.search || "").replace(/&/gi, ",")) +
      "&scope=openid%20profile%20email&nonce=09876xyz";
    this.setState({ loginType: "line!" });
  }

  handleWeiboLogin() {
    // 라인 state 암호화 필요???
    window.location.href =
      "https://api.weibo.com/oauth2/authorize?response_type=code&client_id=" +
      Const.WEIBO.client_id +
      "&redirect_uri=" +
      window.location.origin +
      "/user/weibo/redirect&state=" +
      (window.location.pathname +
        (window.location.search || "").replace(/&/gi, ",")) +
      "&scope=email&nonce=09876xyz";
    this.setState({ loginType: "weibo!" });
  }
  handleFacebookLogin(response) {
    if (response.status === "connected") {
      AccessToken.getCurrentAccessToken().then(data => {
        console.log(data.accessToken.toString());
      });
    }
  }

  render() {
    const { t } = this.props;
    const { modalVisible } = this.state;
    if (!modalVisible) return null;

    return (
      <div className={verificationStyle.modal}>
        <div className={verificationStyle.modalContent}>
          <span className={verificationStyle.modalTitle}>
            {this.props.modalContents ? this.props.modalContents.title : ""}
          </span>
          <div className={verificationStyle.modalDescriptionContainer}>
            {this.props.modalContents ? this.props.modalContents.info : ""}
          </div>

          <div className={verificationStyle.modalButtonContainer}>
            {/*<button onClick={this.handleFBLoginTest}>*/}
            {/*  Facebook으로 로그인하기*/}
            {/*</button>*/}

            {/*<FacebookTest></FacebookTest>*/}
            {Const.checkDevice() === "ios" ? (
              <ButtonSNS
                title={t("facebook_login")}
                color={"#475993"}
                icon={
                  "https://d15eixcc3515pq.cloudfront.net/Assets/img/logo-facebook.svg"
                }
                className="btn-facebook"
                id="btn-social-login"
                onClick={this.handleFBLoginTest}
              />
            ) : (
              <ButtonSNS
                title={t("facebook_login")}
                color={"#475993"}
                icon={
                  "https://d15eixcc3515pq.cloudfront.net/Assets/img/logo-facebook.svg"
                }
                className="btn-facebook"
                id="btn-social-login"
                onClick={this.handleFBLogin}
              />
            )}

            <ButtonSNS
              title={t("line_login")}
              color={"#5ace5a"}
              icon={
                "https://d15eixcc3515pq.cloudfront.net/Assets/img/logo-line.svg"
              }
              onClick={this.handleLineLogin}
            />
            {/*<ButtonSNS*/}
            {/*  title={t("weibo_login")}*/}
            {/*  color={"#ea533b"}*/}
            {/*  icon={*/}
            {/*    "https://d15eixcc3515pq.cloudfront.net/Assets/img/logo-weibo.svg"*/}
            {/*  }*/}
            {/*  onClick={this.handleWeiboLogin}*/}
            {/*/>*/}
          </div>
        </div>

        <div
          onClick={() =>
            this.setState(
              { modalVisible: false },
              this.props.handleClose ? this.props.handleClose() : null
            )
          }
          className={verificationStyle.modalCloseButton}
        >
          {t("close")}
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    eSESSION: state.data.eSESSION.eSESSION
  };
})(withRouter(withTranslation()(LoginContainer)));
